module.exports = __webpack_public_path__ + "static/sticky_notes-fde5ff8ee991f9da8fa5087e604bb1d4.jpg";